import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  grid: {
    justifyContent: 'space-between'
  },
  claimInfoGroup: {
    width: '100%',
    padding: theme.spacing(2),
    margin: theme.spacing(4, 0),
    border: 0,
    borderRadius: theme.spacing(1),
    background: 'linear-gradient(rgba(150, 202, 255, 0.18), rgba(150, 242, 255, 0.18))'
  },
}));

function ClaimReviewTotals({ claim, breakpoints }) {
  const { t } = useTranslation();
  const classes = useStyles();

  // Defensive check for claim object
  if (!claim) {
    return null;
  }

  const getDamgedPartsText = (claim) => {
    // Defensive check for features array
    if (!claim?.features || !Array.isArray(claim.features)) {
      return '';
    }
    
    const text = claim.features.reduce((acc, part) => {
      if (acc === '') {
        acc = `${part.quantity} - ${part.partNumber}`;
      } else {
        acc = `${acc}   ${part.quantity} - ${part.partNumber}`;
      }

      return acc;
    }, '');
    return text;
  }

  if (claim.totals) {
    return (
      <fieldset className={classes.claimInfoGroup}>
        <Grid container spacing={2} className={classes.grid} direction='row'>

          <Grid item xs={4} key={'Number Of Parts'} {...breakpoints}>
            <Typography variant="h4" color="textPrimary">
              {t('numberOfItems')}
            </Typography>
            <Typography variant="body1" color="textSecondary">
              {claim.features?.length || 0}
            </Typography>
          </Grid>
          <Grid item xs={4} key={'Damaged Parts'} {...breakpoints} style={{ textAlign: 'right' }} >
            <Typography variant="h4" color="textPrimary" >
              {t('parts')}
            </Typography>
            <Typography variant="body1" color="textSecondary">
              {getDamgedPartsText(claim)}
            </Typography>
          </Grid>

        </Grid>
      </fieldset>
    );
  }

  return null;
}

ClaimReviewTotals.propTypes = {
  claim: PropTypes.shape({
    features: PropTypes.arrayOf(
      PropTypes.shape({
        partNumber: PropTypes.string,
        quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ),
    totals: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ])
      })
    )
  }),
  breakpoints: PropTypes.shape({
    xs: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    sm: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    md: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    lg: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    xl: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  })
}

ClaimReviewTotals.defaultProps = {
  breakpoints: {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false
  }
}

export default ClaimReviewTotals
